'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-form.routes';

export class SurveyFormComponent {
  constructor(SurveysService, Auth, $state, dialogs, $filter, $stateParams, $uibModal, SurveyResultsService, $scope) {
    'ngInject';
    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.surveyId = $stateParams.id;
    this.propertyId = $stateParams.propertyId;
    this.contactId = $stateParams.contactId;
    this.emailHash = $stateParams.emailHash;
    this.model = {};
    this.$filter = $filter;
    this.$uibModal = $uibModal;

    this.surveyResult = {
      survey: this.surveyId,
      property: this.propertyId,
      contact: this.contactId,
      data: {}
    };

    if (this.surveyId && this.propertyId && this.contactId && this.emailHash) {

      this.SurveyResultsService.checkParticipation({surveyId: this.surveyId, propertyId: this.propertyId}, participationResult => {

        if (participationResult.participated) {
          this.title = participationResult.surveyTitle;
          this.alreadyParticipated = participationResult;
        }

        if (participationResult.deadlineReached) {
          this.title = participationResult.surveyTitle;
          this.deadlineReached = participationResult.deadlineReached;
          this.deadline = participationResult.deadline;
        }

        if (participationResult.participated !== true && !participationResult.deadlineReached) { // has not participated yet

          this.SurveysService.getForParticipant({id: this.surveyId, propertyId: this.propertyId, contactId: this.contactId, emailHash: this.emailHash}, form => {
            this.schema = form.formSchema;
            this.form = ["*"];
            this.title = form.name;
            this.deadline = form.deadline;
            this.description = form.description;

            this.user = form.forParticipant.contact;
            this.property = form.forParticipant.property;

            this.surveyResult.participantPlain = {
              name: this.user.fullName,
              email: this.user.email,
              propertyAddress: this.property.address,
              propertyUnit: this.property.lotNo
            };

            form.fields.forEach(field => {
              if (field.type == 'ranking') {
                this.model[field.key] = angular.copy(field.enum);
              }

              // Prefill
              if (field.prefill && field.prefilled) {

                let [group, value] = field.prefilled.split(":");

                switch (group) {
                  case 'name':

                    if (this.user) {

                      switch(value) {
                        case 'first':
                          this.model[field.key] = this.user.firstName || '';
                          break;
                        case 'last':
                          this.model[field.key] = this.user.lastName || '';
                          break;
                        case 'full':
                          this.model[field.key] = this.user.fullName || '';
                          break;
                      }
                    }

                    break;
                  case 'profile':

                    if (this.user) {

                      switch(value) {
                        case 'email':
                          this.model[field.key] = this.user.email;
                          break;
                        case 'phone':
                            this.model[field.key] = this.user.phone || '';
                          break;
                        case 'building':
                            this.model[field.key] = this.property.buildingNo || '';
                          break;
                        case 'unit':
                            this.model[field.key] = this.property.lotNo || '';
                          break;
                        case 'street':
                            this.model[field.key] = this.property.address ? this.property.address.street : '';
                          break;
                        case 'address':
                          if (this.property.address) {
                            let oAdr = [];
                            let adr = this.property.address;

                            oAdr.push(adr.street);
                            oAdr.push(", ");
                            if (adr.street2) {
                              oAdr.push(adr.street2);
                              oAdr.push(", ");
                            }
                            oAdr.push(adr.city);
                            oAdr.push(", ");
                            oAdr.push(adr.state);
                            oAdr.push(" ");
                            oAdr.push(adr.zip);

                            this.model[field.key] = oAdr.join("");
                          }
                          break;
                      }

                    }

                    break;
                  case 'date':
                    this.model[field.key] = this.$filter('date')(new Date(), value);
                    break;
                }

              }
            });

          }, _ => {
            console.log("Could not load survey schema from server");
            this.formNotFound = true;
          });

        }

      }, _ => {
        console.log("Could not load survey participation data from server");
        this.formNotFound = true;
      })
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      var onSuccess = (response) => {
        var dlg = this.dialogs.notify("Success", "The survey has been sent successfully");

        dlg.result.then(() => {
          that.sendSuccess = true;
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.surveyResult.data = this.model;

      this.SurveyResultsService.save(this.surveyResult, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.survey.form', [uiRouter])
  .config(routes)
  .component('surveyForm', {
    template: require('./survey-form.html'),
    controller: SurveyFormComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/form/survey-form.component.js